import { render } from "./LandRate.vue?vue&type=template&id=1f397014&scoped=true"
import script from "./LandRate.vue?vue&type=script&lang=js"
export * from "./LandRate.vue?vue&type=script&lang=js"

import "./LandRate.vue?vue&type=style&index=0&id=1f397014&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f397014"]])

export default __exports__